module.exports = __webpack_public_path__ + "static/media/add.13aedd56.svg";